import script from "./TagBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TagBar.vue?vue&type=script&setup=true&lang=js"

import "./TagBar.vue?vue&type=style&index=0&id=41f839b2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f839b2"]])

export default __exports__